import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["definition", "message", "select"]

  connect() {
    this.change()
  }

  change() {
    // Select the definitions whose values match the chosen value.
    this.definitionTargets.forEach(def => {
      def.classList.toggle(
        "is-selected",
        def.dataset.selectDefinitionsValue == this.selectTarget.value,
      )
    })

    // Hide the message if the selected option disables it.
    this.selectTarget.selectedOptions.forEach(option => {
      this.messageTarget.hidden =
        option.value == "" || option.dataset.selectDefinitionsUnhandled
    })
  }
}
